import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  ondcOrdersList,
  editOrder,
  getStatusType
} from "../../actions/orderActions";
import DataGrid from "../../components/Datagrid";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { dateFormatter } from "src/views/greeting/GreetingListView/DateFormate";
const OndcOrders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [statusOptions, setStatusOptions] = useState([]); // list from backend
  const [status, setStatus] = useState(""); // selected status
  const [orderId, setOrderId] = useState("");

  // state for dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;
 // const statusOptions = ["Pending", "Processing", "Completed", "Failed"];

  const redirect = (row) => {
    navigate(`/app/management/ondc-order-details`, { state: { row } });
  };

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setStatus(row.settlementStatus || "");
    setOrderId(row.ondcOrderId || "");
    setOpenDialog(true);
  };

  const redirectToIssues = (row) => {
    navigate(`/app/management/issues/create`, { state: { row } });
    console.log("ro00w", row)
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setStatus("");
  };

 
  const handleSave = () => {
    if (!selectedRow) return;

    const payload = { ondcOrderId: orderId, status: status, customerId: customerId };
    dispatch(editOrder(payload));
    // dispatch your update API call here
    // e.g., dispatch(updateSettlementStatus(selectedRow._id, status))

    // console.log("Saving for:", selectedRow._id, "New status:", status);

    handleCloseDialog();
  };
 useEffect(() => {
    const fetchStatus = async () => {
      try {
        const result = await dispatch(getStatusType());
        // assuming result is an array like ["Pending","Processing","Completed"]
        console.log("status result:", result);

        if (Array.isArray(result)) {
          setStatusOptions(result);
        }
      } catch (error) {
        console.error("Error fetching status:", error);
      }
    };

    fetchStatus();
  }, [dispatch]);
  ////////=======================================================================//////////
 const columns = [
 
  // {
  //   field: "customerName",
  //   headerName: "Customer Name",
  //   valueGetter: ({ row }) => row?.order?.billing?.name || "-",
  //   flex: 1,
  // },
  // {
  //   field: "customerPhone",
  //   headerName: "Phone",
  //   valueGetter: ({ row }) => row?.order?.billing?.phone || "-",
  //   flex: 1,
  // },
  {
    field: "ondcOrderId",
    headerName: "ONDC OrderId",
    flex: 2
  },
  {
    field: "itemName",
    headerName: "Item",
    valueGetter: ({ row }) =>
      row?.order?.quote?.breakup?.[0]?.title || "-",
    flex: 1,
  },
  {
    field: "amount",
    headerName: "Amount",
    valueGetter: ({ row }) =>
      `${row?.order?.quote?.price?.currency || ""} ${
        row?.order?.quote?.price?.value || "-"
      }`,
    flex: 1,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   valueGetter: ({ row }) => row?.order?.state || "-",
  //   flex: 1,
  // },
  {
    field: "createdAt",
    headerName: "Created At",
    valueGetter: ({ row }) =>
      row?.order.created_at ? new Date(row?.order.created_at).toLocaleString() : "-",
    flex: 1,
  },
    {
    field: "updatedAt",
    headerName: "Updated At",
    valueGetter: ({ row }) =>
      row?.order.updated_at ? new Date(row?.order.updated_at).toLocaleString() : "-",
    flex: 1,
  },
  {
    field: "action",
    headerName: "Action",
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Tooltip title="View details">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => redirect(params.row)}
          >
            <RemoveRedEyeRoundedIcon />
          </Box>
        </Tooltip>
        <Tooltip title="Update Status">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => handleEditClick(params.row)}
          >
            <EditIcon />
          </Box>
        </Tooltip>
        <Tooltip title="Create Issues">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => redirectToIssues(params.row)}
          >
          </Box>
        </Tooltip>
      </Box>
    ),
    flex: 1,
  },
];


  
  
 
const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  // console.log("orders", orders)
 useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await dispatch(ondcOrdersList(customerId));
        setOrders(response); // save API response in state
      } catch (err) {
        setError(err.message || "Something went wrong");
      }
    };

    fetchOrders();
  }, [dispatch,customerId]);

  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 4,
        borderRadius: 2,
        margin: "auto",
        marginTop: 4,
        backgroundColor: "#fff",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" color="textPrimary">
            ONDC Orders
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }}>
          <DataGrid
            col={columns}
            data={orders}
            getRowId={(row) => row?._id}
            name=""
          />
        </Grid>
      </Grid>

      {/* Edit Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              label="Order ID"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              fullWidth
              sx={{ mb: 3 }}
            />
           <Autocomplete
              options={statusOptions} // from backend
              value={status}
              onChange={(event, newValue) => setStatus(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Order Status" fullWidth />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default OndcOrders;
